import type * as Types from '../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type WebsiteVersionEventQueryVariables = Types.Exact<{
  eventHandle: Types.Scalars['String'];
}>;

export type WebsiteVersionEventQuery = { __typename?: 'Query'; eventByName?: { __typename?: 'Event'; id: string; featureFlags?: Array<string | null> | null } | null };

export const WebsiteVersionEventDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'WebsiteVersionEvent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventByName' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'name' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'featureFlags' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useWebsiteVersionEventQuery__
 *
 * To run a query within a React component, call `useWebsiteVersionEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebsiteVersionEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebsiteVersionEventQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useWebsiteVersionEventQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<WebsiteVersionEventQuery, WebsiteVersionEventQueryVariables>) {
  return ApolloReactHooks.useQuery<WebsiteVersionEventQuery, WebsiteVersionEventQueryVariables>(WebsiteVersionEventDocument, baseOptions);
}
export function useWebsiteVersionEventLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WebsiteVersionEventQuery, WebsiteVersionEventQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<WebsiteVersionEventQuery, WebsiteVersionEventQueryVariables>(WebsiteVersionEventDocument, baseOptions);
}
export type WebsiteVersionEventQueryHookResult = ReturnType<typeof useWebsiteVersionEventQuery>;
export type WebsiteVersionEventLazyQueryHookResult = ReturnType<typeof useWebsiteVersionEventLazyQuery>;
export type WebsiteVersionEventQueryResult = Apollo.QueryResult<WebsiteVersionEventQuery, WebsiteVersionEventQueryVariables>;
